export default "__VITE_ASSET__0J4seDvK__"